import { InteractionRequiredAuthError, InteractionStatus, SilentRequest } from '@azure/msal-browser';
import { msalInstance } from '../Api';
import { scopes as msalScopes } from './msalConfig';

export const fetchServiceTokenAsync = async (scopes?) => {
  const accessTokenRequest: SilentRequest = {
    scopes: scopes || msalScopes.scopes,
  };
  try {
    // acquireTokenSilent() handles token caching and renewal so no need for custom logic
    // @link https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/0f313aa216ad9620c3e46a028516bb02bc3d118c/lib/msal-browser/docs/token-lifetimes.md
    const { accessToken } = await msalInstance.acquireTokenSilent(accessTokenRequest);
    return accessToken;
  } catch (err) {
    if (err instanceof InteractionRequiredAuthError) {
      msalInstance.acquireTokenRedirect(accessTokenRequest);
    }
  }
};
